module.exports = __webpack_public_path__ + "img/5.f0a8b338.jpg";